import React from "react";
import success from "../assets/verified.gif"
import "../styles/Callback.scss";
import { Link, useNavigate } from "react-router-dom";
const Callback = ({callbackData,setCallbackPage}) => {
  
const navigate = useNavigate();

const navigateToHome = ()=>{
  setCallbackPage(false);
  navigate("/")

}

  return (
    <>
      <div class="callback_status parent">
        <img src={success} alt=""/>
        <h3>
          ₹{callbackData?.amountPaid}
        </h3>
        <p>
          {callbackData?.message}
        </p>
       <p  className="payer_name">
        {callbackData?.payerName}
       </p>

       <div onClick={navigateToHome} className="btn" >
       Back To Home
       </div>
      </div>
    </>
  );
};

export default Callback;
